import { MakeCall } from 'ha/services/apiV2/createMakeCall';

import { Qualification } from './types/Qualification';

export default (makeCall: MakeCall) => (userId: number) =>
  makeCall<Qualification>('GET', `/api/v2/user/${userId}/qualification`);
